module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "pz5-1"
    }
  }, [_vm._v("\n\t\t\t\t\tAcclaim for "), _c('i', [_vm._v("Little Birds with Broken Wings")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz5-3"
    }
  }, [_vm._v("\n\t\t\t\t\t“For three decades, David Martin’s goal has been to engage people in the writing\n\t\t\t\t\tprocess, whatever the form: poetry, journaling, essays, and stories. ‘Just write,’\n\t\t\t\t\the says and sets an example with strong and insightful writing in his personal essays\n\t\t\t\t\tthat enlighten and inspire.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "A6"
    }
  }, [_vm._v("\n\t\t\t\t\t-Betty Segell, English teacher ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz5-4"
    }
  }, [_c('i', [_vm._v("“Fine Lines")]), _vm._v(" is a prime example of the extraordinary result that takes place when\n\t\t\t\t\ttalented writing meets experienced editing. In this collection of his own work, David\n\t\t\t\t\tMartin has once again delivered an Easter basket filled with mind candy. Unwrapping\n\t\t\t\t\teach page is a pleasure.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr2",
    attrs: {
      "id": "Al"
    }
  }, [_vm._v("\n\t\t\t\t\t-Lori Gottula, reporter, free-lance writer,")]), _vm._v(" "), _c('p', {
    staticClass: "txr1"
  }, [_vm._v("\n\t\t\t\t\tauthor of "), _c('i', [_vm._v("SISSY AND ANGEL")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz5-5"
    }
  }, [_vm._v("\n\t\t\t\t\t“Most educators would agree that it is impossible to enlighten others, when teachers\n\t\t\t\t\tdo not model the desired work themselves. Each edition of "), _c('i', [_vm._v("Fine Lines")]), _vm._v(" begins with\n\t\t\t\t\ta personal essay written by David Martin, and his words capture the spirit of that\n\t\t\t\t\tparticular issue. He is relentless, encouraging others to love written expression,\n\t\t\t\t\twriting with passion and integrity, and communicating precisely. He expects no less\n\t\t\t\t\tof himself. From compassion, words of inspiration, psychological and emotional healing,\n\t\t\t\t\texamining relationships, to the creation of a Zen-like simplicity and balance, his\n\t\t\t\t\tessays speak to those beginning their paths of awareness and those continuing their\n\t\t\t\t\tlifetime journeys toward integrity. Martin’s profound, sometimes humorous, experiences\n\t\t\t\t\tand gems of wisdom bring clarity of perception and a sense of the sacred into everyday\n\t\t\t\t\texperiences.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr2",
    attrs: {
      "id": "AyA"
    }
  }, [_vm._v("\n\t\t\t\t\t-Stan Maliszewski, PhD, Professor of")]), _vm._v(" "), _c('p', {
    staticClass: "txr1"
  }, [_vm._v("\n\t\t\t\t\tCounseling Psychology, University of Arizona")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz6-1"
    }
  }, [_vm._v("\n\t\t\t\t\t“This is a selection of David Martin’s work, originally published in "), _c('i', [_vm._v("Fine Lines")]), _vm._v(":\n\t\t\t\t\t"), _c('i', [_vm._v("A Literary Journal")]), _vm._v(", during its second decade. The essays, poems, and reviews collected\n\t\t\t\t\there are the delightful products of alchemy: imagination, language, and discipline.\n\t\t\t\t\tHe shares the process and insights of his writing, teaching, and self-exploration\n\t\t\t\t\twith clarity, artistry, and fearless honesty.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "AvS"
    }
  }, [_vm._v("\n\t\t\t\t\t- Marcia Calhoun Forecki, author of "), _c('i', [_vm._v("Hurricane Blues")]), _vm._v(", and editor ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz6-2"
    }
  }, [_vm._v("\n\t\t\t\t\t“I enjoyed exploring Martin’s first collection ("), _c('i', [_vm._v("Facing the Blank Page, 1992-2001")]), _vm._v(")\n\t\t\t\t\tand look forward to this next volume of shared creativity. When we allow our words\n\t\t\t\t\tto carry the spirit of ourselves, as he does, they resonate powerfully, indeed.”\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "AmA"
    }
  }, [_vm._v("\n\t\t\t\t\t–Maria Harding, principal flute, Omaha Symphony ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz6-3"
    }
  }, [_vm._v("\n\t\t\t\t\t“David Martin lives and breathes writing. Throughout his teaching career, he has\n\t\t\t\t\tintroduced thousands, from ages six to ninety-six, to the joy of putting one’s thoughts\n\t\t\t\t\tand experiences into words. He writes as well as he teaches, which you will discover\n\t\t\t\t\there. So, grab a favorite beverage, sit back, put your feet up, and let him work\n\t\t\t\t\this magic with words.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "pz6-4"
    }
  }, [_vm._v("\n\t\t\t\t\t-Richard C. Meyer, author of "), _c('i', [_vm._v("One Anothering, Volumes I, II, & III")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz6-5"
    }
  }, [_vm._v("\n\t\t\t\t\t“David Martin created "), _c('i', [_vm._v("Fine Lines")]), _vm._v(" to give burgeoning writers an outlet for sharing\n\t\t\t\t\ttheir creative voices. He believes in the power of the written word to change lives\n\t\t\t\t\tand unite people across cultures by finding their common bonds. His national journal\n\t\t\t\t\treflects this belief and demonstrates a dedication to readers and writers of all\n\t\t\t\t\tages. His own essays fill this second book and will both entertain and enlighten\n\t\t\t\t\treaders.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "ABc"
    }
  }, [_vm._v("\n\t\t\t\t\t-Devon McPherson, writer, lives in Sweden ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz6-6"
    }
  }, [_vm._v("\n\t\t\t\t\t“These essays and poems of David Martin reveal in their collected shape the insights\n\t\t\t\t\tsupporting the editorial structure of "), _c('i', [_vm._v("Fine Lines")]), _vm._v(". They reveal the agile mind and\n\t\t\t\t\tnecessarily broad attention needed to be a long-term editor. Topics range from baseball\n\t\t\t\t\tto classical music to the nature of time. Martin is in the perfect position to offer\n\t\t\t\t\this thoughts on writing, life, and the writing life. These editorials and other selections\n\t\t\t\t\tbring the practices of writing, teaching, and reading together in thoughtful ways\n\t\t\t\t\tthat will benefit students and "), _c('span', {
    attrs: {
      "id": "z7-1"
    }
  }, [_vm._v("instructors. He has a cautious wisdom to share; he\n\t\t\t\t\tis careful never to preach. We travel with him along the path, and he, like a skilled\n\t\t\t\t\twilderness guide, points to useful and dangerous things, explaining the experiences\n\t\t\t\t\the has had with each. We are drawn into his careful, insightful narratives, and,\n\t\t\t\t\tbecause we have the context of the story, we learn each lesson better.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "txr2",
    attrs: {
      "id": "pz7-2"
    }
  }, [_vm._v("\n\t\t\t\t\t-Dr. James Engelhardt, PhD, acquisitions editor")]), _vm._v(" "), _c('p', {
    staticClass: "txr1"
  }, [_vm._v("\n\t\t\t\t\tat the University of Alaska Press")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz7-3"
    }
  }, [_vm._v("\n\t\t\t\t\t“When I met David Martin at a writing workshop, his enthusiasm for the written word\n\t\t\t\t\twas a great motivator to a closet writer like me, but it wasn’t until I read one\n\t\t\t\t\tof his essays that I understood his love affair with words. To have a collection\n\t\t\t\t\tof his essays and poems is like having a cornucopia feast of images, ideas, and emotions.\n\t\t\t\t\tWhether it is a light poem or a full-bodied, soul-searching essay, he leaves the\n\t\t\t\t\treader with a sense of wonder that only a talented wordsmith can accomplish. His\n\t\t\t\t\twork encourages me to visualize images, ponder ideas, feel emotions, and put pen\n\t\t\t\t\tto paper to express myself. This collection not only gives the reader a peek into\n\t\t\t\t\this world but shows how writing can be the common bond that unites all of us. Martin’s\n\t\t\t\t\tfavorite phrase is ‘Write On.’ My hope is this consummate teacher continues to ‘write\n\t\t\t\t\ton’ and shares with us the insights and knowledge he discovers along the way.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "ATy"
    }
  }, [_vm._v("\n\t\t\t\t\t-Jayne A. Schlosser, observational essayist ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz7-4"
    }
  }, [_vm._v("\n\t\t\t\t\t“David Martin is a distinguished author and teacher. I have had the good fortune\n\t\t\t\t\tto work with him in Nebraska’s largest high school and as an editor with "), _c('i', [_vm._v("Fine Lines")]), _vm._v(".\n\t\t\t\t\tHe created this literary journal as an avenue through which writers of all ages could\n\t\t\t\t\tbe creative using the written word. He gives encouragement, praises freely, boosts\n\t\t\t\t\tconfidence, and inspires all. He writes from the heart and motivates students to\n\t\t\t\t\tthink and do their best. He is passionate, thoughtful, and reflective in his pursuit\n\t\t\t\t\tof truth and accuracy. His essays are thought provoking and meaningful. He has been\n\t\t\t\t\ta monumental force in fostering my own writing potential. It has been a privilege\n\t\t\t\t\tto work with and be shaped by such an incredible role model.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "Aqf"
    }
  }, [_vm._v("\n\t\t\t\t\t-Wendy Lundeen, Spanish teacher ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-1"
    }
  }, [_vm._v("\n\t\t\t\t\t“David Martin’s gentle spirit, coupled with a profound sense of understanding, is\n\t\t\t\t\tprojected through a strong voice of sincere interest for the reader. His essays are\n\t\t\t\t\tenlightening and entertaining, speaking to the reader on a personal level, while\n\t\t\t\t\tbroadening one’s views. He displays colorful word pictures, drawing the reader into\n\t\t\t\t\tthe place where little details formulate a larger scene, and the mind’s eye captures\n\t\t\t\t\tmore truths about life, writing, and the mission beyond self. His dedication and\n\t\t\t\t\tcontribution to readers and writers is immense. Enjoy!” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "AlL"
    }
  }, [_vm._v("\n\t\t\t\t\t-Shawnelle Alley, college student, artist ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-2"
    }
  }, [_vm._v("\n\t\t\t\t\t“As a writer myself and guest speaker at "), _c('i', [_vm._v("Fine Lines")]), _vm._v(" Summer Camps, I have had the\n\t\t\t\t\topportunity to witness Martin’s passion for and his devotion to the written word.\n\t\t\t\t\tHis spirit for writing is infectious, and his presence is one of gentleness. From\n\t\t\t\t\thim, a writer, to me, a dancer, he once said, ‘You dance on the stage, and I try\n\t\t\t\t\tto dance on the page.’ With each opportunity I have had to work with him, I have\n\t\t\t\t\talways been challenged with the best of questions and insights into the creative\n\t\t\t\t\tprocess. The result of this experience is a journey into which we are about to embark\n\t\t\t\t\tas we read this next collection. His unique style will walk us into a garden of well-written\n\t\t\t\t\tprose.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "ASl"
    }
  }, [_vm._v("\n\t\t\t\t\t-Julian Adair, dance choreographer ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-3"
    }
  }, [_vm._v("\n\t\t\t\t\t“Martin’s efforts to encourage writers stretch across generations and decades. As\n\t\t\t\t\tthe founder and managing editor of "), _c('i', [_vm._v("Fine Lines")]), _vm._v(", he presents creative people, particularly\n\t\t\t\t\treaching out to the young, with the opportunity of seeing their name and work in\n\t\t\t\t\tprint, and that’s a thrill, no matter the age.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "A_2"
    }
  }, [_vm._v("\n\t\t\t\t\t-Connie Spittler, teacher and author ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz8-4"
    }
  }, [_vm._v("\n\t\t\t\t\t“It is hard to read one of Martin’s essays without the immediate urge to put a pencil\n\t\t\t\t\tto a blank page and start typing the novel that’s been spinning inside of my head.\n\t\t\t\t\tHe has a way of seeing the world and sharing his views that jump starts my day and\n\t\t\t\t\thas me seeking my own experiences to write about. His wisdom touches on so many subjects;\n\t\t\t\t\the helps to sort out the incongruities of the universe with elegant but approachable\n\t\t\t\t\tprose.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "A4"
    }
  }, [_vm._v("\n\t\t\t\t\t-Jeff Grinvalds, teacher and website designer ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz9-1"
    }
  }, [_vm._v("\n\t\t\t\t\t“I look forward to every "), _c('i', [_vm._v("Fine Lines")]), _vm._v(" issue, knowing Martin’s essay will be full of\n\t\t\t\t\tenergy and have an insightful and pithy quality. Just like his ‘mentors,’ Socrates\n\t\t\t\t\tand Emily Dickinson, he examines any subject and thought for what it brings to the\n\t\t\t\t\twell-examined life. He has a real gift of precision and directness from which I can\n\t\t\t\t\talways take away a nugget for myself.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "AvG"
    }
  }, [_vm._v("\n\t\t\t\t\t-Stephen Gehring, lawyer ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz9-2"
    }
  }, [_vm._v("\n\t\t\t\t\t“Martin is a true gift to the writing world. He brings new insights to everyday life,\n\t\t\t\t\tand his passion for writing flows through each carefully crafted sentence and paragraph.\n\t\t\t\t\tHe has a profound impact on writers, whose lives he touches. He is the steady rain\n\t\t\t\t\tthat turns the slow moving creek water into a torrent of creativity and purpose.\n\t\t\t\t\tI was once that wandering stream.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr2",
    attrs: {
      "id": "pz9-3"
    }
  }, [_vm._v("\n\t\t\t\t\t-Chris Raabe, middle school teacher,")]), _vm._v(" "), _c('p', {
    staticClass: "txr1"
  }, [_vm._v("\n\t\t\t\t\tauthor of "), _c('i', [_vm._v("The New Phenomenon")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz9-4"
    }
  }, [_vm._v("\n\t\t\t\t\t“The writing from the heart and mind of David Martin is at once clear and penetrating.\n\t\t\t\t\tHis words flow outward and inward with purpose, what Robert Bly called the difference\n\t\t\t\t\tbetween depression and soul. He touches what matters most, something intimate and\n\t\t\t\t\tmissed. He knows the route of exploring the internal and external landscapes, mirroring\n\t\t\t\t\teach other in the common and divine. Thank you, Coach Martin.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "ApF"
    }
  }, [_vm._v("\n\t\t\t\t\t-Sjon Ashby, English Instructor, Bellevue University ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz9-5"
    }
  }, [_vm._v("\n\t\t\t\t\t“Martin’s essays ignite the imagination, challenge the gloom, rekindle the awe, and\n\t\t\t\t\tinvite all of us to see the world with the celebration of the heart. He shares with\n\t\t\t\t\treaders the truths and wisdoms unearthed in the writings of others and the writings\n\t\t\t\t\tyet to be written within us. To read his truths is to smile at a stranger across\n\t\t\t\t\tdistances of place, talent, years, and cultures. Read his essays and be glad TO BE\n\t\t\t\t\ta part of this world, this time, this place.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr2",
    attrs: {
      "id": "pz9-6"
    }
  }, [_vm._v("\n\t\t\t\t\t-Nancy Genevieve Perkins-Kohl, Associate Professor")]), _vm._v(" "), _c('p', {
    staticClass: "txr1"
  }, [_vm._v("\n\t\t\t\t\tEmerita of English, University of Illinois at Springfield")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz9-8"
    }
  }, [_vm._v("\n\t\t\t\t\t“David Martin is a Living Treasure for writing. His essays – and writing life – are\n\t\t\t\t\tan inspiration to generations of writers, from Omaha to the wider world. The reach\n\t\t\t\t\tof his "), _c('i', [_vm._v("Fine Lines")]), _vm._v(" extends into classrooms all across the continent, as well as into\n\t\t\t\t\tthe more private "), _c('span', {
    attrs: {
      "id": "z10-1"
    }
  }, [_vm._v("spaces where individual writers toil for meaning. This collection\n\t\t\t\t\tof pieces from the last ten years of "), _c('i', [_vm._v("Fine Lines")]), _vm._v(" is to be celebrated by writers and\n\t\t\t\t\twriting teachers everywhere.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "txr2",
    attrs: {
      "id": "pz10-2"
    }
  }, [_vm._v("\n\t\t\t\t\t-Robert E. Brooke, Professor of English,")]), _vm._v(" "), _c('p', {
    staticClass: "txr1"
  }, [_vm._v("\n\t\t\t\t\tDirector - Nebraska Writing Project")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-3"
    }
  }, [_vm._v("\n\t\t\t\t\t“While keyboards may have replaced pencils, nothing can replace the communication\n\t\t\t\t\tbetween two souls. David Martin continues to pour his soul into writing as he has\n\t\t\t\t\tfor decades. Not only does he work tirelessly to reach people through his own writing,\n\t\t\t\t\the strives to awaken the reticent writer in all of us. It has become the mode in\n\t\t\t\t\tpopular culture to surround oneself with loud noise, flashy colors, and fiery explosions\n\t\t\t\t\t(think pop singers screaming out their words of angst). Thank goodness, Martin still\n\t\t\t\t\twrites and teaches with the power of "), _c('i', [_vm._v("subtlety")]), _vm._v(" and "), _c('i', [_vm._v("nuance")]), _vm._v(" of the written word. In\n\t\t\t\t\tan interview he described the metaphorical “slaying of dragons” as it relates to\n\t\t\t\t\twriting. Reading his words helps remind and encourage writers in this technological\n\t\t\t\t\tage to slay perhaps the biggest dragon of all, the blank page.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "Axl"
    }
  }, [_vm._v("\n\t\t\t\t\t-Kathy Maloney, writer and artist ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-4"
    }
  }, [_vm._v("\n\t\t\t\t\t“As a teacher, David Martin has dedicated much of his career to encouraging young\n\t\t\t\t\twriters of all ages by putting their work into print. Given his long-standing commitment\n\t\t\t\t\tto publishing others, it is nice to see a second volume dedicated to his own work.\n\t\t\t\t\tMartin’s writing is rich in personal anecdotes and sensitive reflections on human\n\t\t\t\t\texperience. More than anything else, though, he revels in the creative process itself.\n\t\t\t\t\tHe verifies, time and again, the value of writing as a vital act of self-discovery,\n\t\t\t\t\tclarification, and affirmation – which must be ongoing throughout the author’s life.\n\t\t\t\t\tIt is a pleasure to read these highly personal avowals of the power of written expression.”\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "AO4"
    }
  }, [_vm._v("\n\t\t\t\t\t-Rachel Danford, art historian, John Hopkins University ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz10-5"
    }
  }, [_vm._v("\n\t\t\t\t\t“The writing in "), _c('i', [_vm._v("Little Birds with Broken Wings")]), _vm._v(" reveals a creative soul that actively\n\t\t\t\t\tcarves out and brings meaning to this chaotic life. Martin’s words inspire and push\n\t\t\t\t\tme into a beautiful space of reflection and admiration.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "AEl"
    }
  }, [_vm._v("\n\t\t\t\t\t-Karleen Gebhardt, English instructor ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a677eeae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter01.vue
// module id = 66
// module chunks = 0